module.exports = __webpack_public_path__ + "img/search-box2.7a094398.png";